import "./@core/components/ripple-button";
// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss";
// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./table.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";

import { store } from "@store/store";
import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

// ** ThemeColors Context
import Spinner from "./@core/components/spinner/Fallback-spinner";
import themeConfig from "./configs/themeConfig";
// ** Service Worker
import * as serviceWorker from "./serviceWorker";
import { ThemeContext } from "./utility/context/ThemeColors";
import { ConfirmationDialogProvider } from "./@core/ConfirmationDialog";


// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <ThemeContext>
            <ConfirmationDialogProvider>
              <Toaster
                position={themeConfig.layout.toastPosition}
                toastOptions={{ className: "react-hot-toast" }}
              />
              <LazyApp />
            </ConfirmationDialogProvider>
          </ThemeContext>
        </QueryParamProvider>
      </Suspense>
    </Provider>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
